import * as React from "react";
import NavBar from "../components/NavBar";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {FormControl, FormControlLabel, RadioGroup, Radio} from "@mui/material";
import {handleBorderColor} from "../assets/js/main";

export default function PostexRate() {
  const {t} = useTranslation()
  const [searchParams] = useSearchParams();
  const [selectVal, setSelectVal] = React.useState('');
  const [radio1, setRadio1] = React.useState('');
  const [radio2, setRadio2] = React.useState('');
  const [radio3, setRadio3] = React.useState('');
  const [radio4, setRadio4] = React.useState('');
  const [radio5, setRadio5] = React.useState('');
  const [radio6, setRadio6] = React.useState('');
  const [radio7, setRadio7] = React.useState('');


  return (
     <>
       <NavBar blue back/>
       <div className="container">
         <div className="ratePage desktopSection">
           <div className="title-page">
             <div>
               <h2>{t("rate.t1")}</h2>
               <p className="desc">{t("rate.t2")}</p>
             </div>
             <img src="/Logo.png" alt="postex" loading="lazy"/>
           </div>


           <p className="mb-3">{t("rate.t3")}</p>
           <div className="row mb-3">
             <div className="col-12 col-md-6 col-lg-4">
               <select aria-label="Default select example" defaultValue={selectVal}
                       id="selectVal"
                       onChange={(event) => {
                         setSelectVal(event?.target?.value)
                       }}>
                 <option value="" selected disabled>{t("wallet.t3")}</option>
                 <option value="1">1</option>
                 <option value="2">2</option>
                 <option value="3">3</option>
                 <option value="4">4</option>
                 <option value="5">5</option>
                 <option value="6">6</option>
                 <option value="7">7</option>
                 <option value="8">8</option>
                 <option value="9">9</option>
                 <option value="10">10</option>
               </select>
             </div>
           </div>

           <FormControl>
             <p>{t("rate.t7")}</p>
             <RadioGroup
                id="radio1"
                aria-labelledby="demo-radio-buttons-group-label"
                value={radio1}
                onChange={(e) => setRadio1(e.target.value)}
                name="radio-buttons-group"
             >
               <FormControlLabel value="0" control={<Radio/>} label={t("rate.t8")}/>
               <FormControlLabel value="1" control={<Radio/>} label={t("rate.t9")}/>
               <FormControlLabel value="2" control={<Radio/>} label={t("rate.t10")}/>
             </RadioGroup>
           </FormControl>

           <FormControl>
             <p>{t("rate.t11")}</p>
             <RadioGroup
                id="radio2"
                aria-labelledby="demo-radio-buttons-group-label"
                value={radio2}
                onChange={(e) => setRadio2(e.target.value)}
                name="radio-buttons-group"
             >
               <FormControlLabel value="0" control={<Radio/>} label={t("rate.t12")}/>
               <FormControlLabel value="1" control={<Radio/>} label={t("rate.t13")}/>
               <FormControlLabel value="2" control={<Radio/>} label={t("rate.t14")}/>
               <FormControlLabel value="3" control={<Radio/>} label={t("rate.t15")}/>
               <FormControlLabel value="4" control={<Radio/>} label={t("rate.t16")}/>
             </RadioGroup>
           </FormControl>

           <FormControl>
             <p>{t("rate.t17")}</p>
             <RadioGroup
                id="radio3"
                aria-labelledby="demo-radio-buttons-group-label"
                value={radio3}
                onChange={(e) => setRadio3(e.target.value)}
                name="radio-buttons-group"
             >
               <FormControlLabel value="0" control={<Radio/>} label={t("rate.t18")}/>
               <FormControlLabel value="1" control={<Radio/>} label={t("rate.t19")}/>
               <FormControlLabel value="2" control={<Radio/>} label={t("rate.t20")}/>
             </RadioGroup>
           </FormControl>

           <FormControl>
             <p>{t("rate.t21")}</p>
             <RadioGroup
                id="radio4"
                aria-labelledby="demo-radio-buttons-group-label"
                value={radio4}
                onChange={(e) => setRadio4(e.target.value)} name="radio-buttons-group"
             >
               <FormControlLabel value="0" control={<Radio/>} label={t("rate.t22")}/>
               <FormControlLabel value="1" control={<Radio/>} label={t("rate.t23")}/>
               <FormControlLabel value="2" control={<Radio/>} label={t("rate.t24")}/>
             </RadioGroup>
           </FormControl>

           <FormControl>
             <p>{t("rate.t25")}</p>
             <RadioGroup
                id="radio5"
                aria-labelledby="demo-radio-buttons-group-label"
                value={radio5}
                onChange={(e) => setRadio5(e.target.value)} name="radio-buttons-group"
             >
               <FormControlLabel value="0" control={<Radio/>} label={t("rate.t26")}/>
               <FormControlLabel value="1" control={<Radio/>} label={t("rate.t27")}/>
               <FormControlLabel value="2" control={<Radio/>} label={t("rate.t28")}/>
             </RadioGroup>
           </FormControl>

           <FormControl>
             <p>{t("rate.t29")}</p>
             <RadioGroup
                id="radio6"
                aria-labelledby="demo-radio-buttons-group-label"
                value={radio6}
                onChange={(e) => setRadio6(e.target.value)} name="radio-buttons-group"
             >
               <FormControlLabel value="0" control={<Radio/>} label={t("rate.t30")}/>
               <FormControlLabel value="1" control={<Radio/>} label={t("rate.t31")}/>
               <FormControlLabel value="2" control={<Radio/>} label={t("rate.t32")}/>
             </RadioGroup>
           </FormControl>

           {/*<FormControl>*/}
           {/*  <p>{t("rate.t28")}</p>*/}
           {/*  <RadioGroup*/}
           {/*     id="radio7"*/}
           {/*     aria-labelledby="demo-radio-buttons-group-label"*/}
           {/*     value={radio7}*/}
           {/*     onChange={(e) => setRadio7(e.target.value)} name="radio-buttons-group"*/}
           {/*  >*/}
           {/*    <FormControlLabel value="0" control={<Radio/>} label={t("rate.t29")}/>*/}
           {/*    <FormControlLabel value="1" control={<Radio/>} label={t("rate.t30")}/>*/}
           {/*    <FormControlLabel value="2" control={<Radio/>} label={t("rate.t31")}/>*/}
           {/*  </RadioGroup>*/}
           {/*</FormControl>*/}


           <p className="mb-3">{t("rate.t33")}</p>
           <textarea name="desc" cols="30" rows="5" id="desc"/>


           <div className="_btnGroup_yellow justify-content-end">
             <button className="btnFill" id="submit">
               <span>{t("rate.t34")}</span>
             </button>
           </div>
         </div>
       </div>
     </>
  )
}
